// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface SegmentConfigOut {}

export const SegmentConfigOutSerializer = {
  _fromJsonObject(_object: any): SegmentConfigOut {
    return {};
  },

  _toJsonObject(_self: SegmentConfigOut): any {
    return {};
  },
};
